import React from "react";
import { Header } from "@/widgets/header";
import { Footer } from "@/widgets/footer";
import { CompanyContent } from "@/features/company";

/**
 * CompanyPage - Wrapper 컴포넌트
 * 레이아웃만 담당하고 콘텐츠는 features/company에서 관리
 */
export function CompanyPage() {
  return (
    <div className="w-full flex flex-col bg-white">
      {/* Main Content */}
      <CompanyContent />
    </div>
  );
}
